import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/goodsRelease/applyList',
    name: 'goodsReleaseApplyList',
    component: () => import('@/sub-app/goodsRelease/pages/applyAndApprove/applyList.vue'),
    meta: {
      title: '物品放行',
      keepAlive: true,
    },
  },
  {
    path: '/goodsRelease/adminList',
    name: 'goodsReleaseAdminList',
    component: () => import('@/sub-app/goodsRelease/pages/applyAndApprove/adminList.vue'),
    meta: {
      title: '物品放行',
      keepAlive: true,
    },
  },
  {
    path: '/goodsRelease/audit',
    name: 'goodsReleaseAudit',
    component: () => import('@/sub-app/goodsRelease/pages/audit.vue'),
    meta: {
      title: '同意审批/退回发起人',
      keepAlive: false,
    },
  },
  {
    path: '/goodsRelease/applyDetail',
    name: 'goodsReleaseApplyDetail',
    component: () => import('@/sub-app/goodsRelease/pages/applyDetail.vue'),
    meta: {
      title: '物品放行',
      keepAlive: false,
    },
  },
  {
    path: '/goodsRelease/apply',
    name: 'goodsReleaseApply',
    component: () => import('@/sub-app/goodsRelease/pages/apply.vue'),
    meta: {
      title: '物品放行',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
